import $ from 'jquery';
import slick from 'slick-carousel/slick/slick.js';
import {GLOBAL_PATH, STORE} from "../common/Model";
import Utils from "../common/Utils";
import {communityHomeL10n} from "../common/L10n";

export default class promotion {
	constructor(_config) {
		this.config = _config;
		window.jQuery = window.$ = $;
		let _option = {
			type: 'api',
			service : this.config.service,
			menu : 'promotion',
			locale : this.config.locale,
			country : this.config.country
		};
		this.promotionApiUrl = GLOBAL_PATH(_option);
		this.l10n = communityHomeL10n[this.config.lang];
		// console.log('# promotionSlick.js this.l10n : ', this.l10n, this.config.lang);
		// this.l10n.viewAll = window.communityHomel10n ? window.communityHomel10n.viewAll : this.config.isGlobal ? 'View All' : '전체보기';
		// console.log( '=> promotion.js this.promotionApiUrl : ', this.promotionApiUrl);
	}

	init() {
		if ( document.querySelector('.home-promotion').childNodes.length > 0 ) { // lineagew
			this.set();
		} else {
			if (Utils.isEmptyObject(STORE.data.promotion) ) {
				this.get();
			} else {
				this.render(STORE.data.promotion);
			}
		}
	}

	set() {
		let _isRtl = this.config.isRtl;
		if(_isRtl) {
			let _items = document.querySelectorAll('.promotion-list .promotion-bg[data-device=pc]');
			_items.forEach( el => {
				el.classList.add('disabled');
				if( el.getAttribute('data-rtl') != '' ) el.setAttribute('background-image', 'url('+ el.getAttribute('data-rtl') +')' );
			});
			/*$.each( $('.promotion-list').find('.promotion-bg[data-device=pc]'), function(i, v ){
				// console.log( '=> homePromotionSlick.js .data-rtl : ',  $(this).attr('data-rtl') );
				if( $(this).attr('data-rtl') && $(this).attr('data-rtl') != '' ) {
					$(this).css('background-image', 'url('+ $(this).attr('data-rtl') +')' )
				}
			});*/
		}
		this.addEvent();
	}

	get() {
		const _this =  this;
		fetch(this.promotionApiUrl, {
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			}
		}).then(function (response) { // The API call was successful!
			if (response.ok) {
				return response.json();
			} else {
				return Promise.reject(response);
			}
		}).then(function (data) { // This is the JSON from our response
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json;
			} else {
				_resData = data;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.promotion = _resData;
			_this.render(_resData);
		}).catch(function (err) { // There was an error
			// console.warn('Something went wrong.', err);
			console.log('오류가 발생했습니다.', err);
		});
		/*$.ajax({
			dataType: "json",
			type: "GET",
			headers: {
				'Content-Type': 'application/json', 'Accept': 'application/json'
			},
			url: `${this.promotionApiUrl}`
		})
		.fail( xhr => console.log('오류가 발생했습니다.') )
		.done(( data ) => {
			let _resData;
			if(data.jsonData) {
				let json = JSON.parse(data.jsonData);
				_resData = json;
			} else {
				_resData = data;
			}
			if(! _resData || _resData.length <= 0 ) return;
			STORE.data.promotion = _resData;
			this.render(_resData);
		});*/
	}
	render(data) {
		const wrapper = document.querySelector('.home-promotion');
		const tmpl = this.templ(data);
		wrapper.innerHTML = tmpl;
		this.addEvent();
	}
	templ(_d){
		return `		
			<div class="promotion-list">
				${_d.list.map( (item, index) => {
					return this.listTempl(item);
				}).join('')}
			</div>
			<div class="promotion-thumb">
				${_d.list.map( (item, index) => {
					return this.thumbListTempl(item);
				}).join('')}
			</div>
			<button class="promotion-listall-button is-active">${this.l10n.viewAll}</button>
			<div class="promotion-listall-wrapper">
				<div class="promotion-listall"> 
				<div class="promotion-listall-list-wrapper">
					<button class="promotion-listall-close"></button>
					<div class="promotion-listall-list">
					${_d.list.map( (item, index) => {
						return this.allListTempl(item);
					}).join('')}
					</div>
				</div>
				</div>
			</div>
			
			<div class="promotion-pagination"></div>
			<button class="promotion-button-prev"></button>
			<button class="promotion-button-next"></button>

			`;
	}

	listTempl(_a) {
		let _isRtl = this.config.isRtl;
		return `
			<div class="promotion-item">
				<div class="promotion-bg" data-device="mobile" style="background-image: url('${_a.moibleImage}')"></div>
				<div class="promotion-bg" data-device="pc" style="background-image: url('${_isRtl ? `${_a.pcRtlImage}` : `${_a.pcImage}`}')" data-ltl="${_a.pcImage}" data-rtl="${_a.pcRtlImage}"></div>
				${_a.movie ?
				`<div class="promotion-movie">
					<video playsinline loop="true" autoplay="" muted="" poster="">
						<source src="${_a.movie}" type="video/mp4">
					</video>
				</div>` : ``}
				<div class="promotion-info">
					<a href="${_a.url}" ${_a.target ? `target="_blank"` : ``}>
						${_a.label ? `<div class="promotion-flag"><span class="flag-event">${_a.label}</span></div>` : ``}
						<h3 class="promotion-title">${_a.title}</h3>
						<div class="promotion-desc">${_a.desc}</div>
					</a>
				</div>
			</div>`;
	}
	thumbListTempl(_a) {
		return `
			<div class="promotion-item">
				<span class="title">${_a.shortTitle}</span>
			</div>
			`;
	}
	allListTempl(_a) {
		return `
			<div class="promotion-listall-item">
				<a href="${_a.url}" ${_a.target ? `target="_blank"` : ``}>
				<div class="promotion-listall-thumb"><img src="${_a.thumb}" alt=""></div>
				<div class="promotion-listall-title">${_a.shortTitle}</div>
				</a>
			</div>
			`;
	}


	addEvent() {
		/*template 으로 이동
		let _isRtl = this.config.isRtl;
		if(_isRtl) {
			$.each( $('.promotion-list').find('.promotion-bg[data-device=pc]'), function(i, v ){
				// console.log( '=> homePromotionSlick.js .data-rtl : ',  $(this).attr('data-rtl') );
				if( $(this).attr('data-rtl') && $(this).attr('data-rtl') != '' ) {
					$(this).css('background-image', 'url('+ $(this).attr('data-rtl') +')' )
				}
			});
		}*/
		this.setSlick();
		this.toggleEvent();
		this.onWindowResize();
		this.bindingEvent();
	}

	bindingEvent() {
		window.addEventListener('resize', (evt) => {
			this.onWindowResize();
		});
		// $(window).on('resize', this.onWindowResize);
	}

	/* legacy setThumbWidth() {
		let length = $('.promotion-list .promotion-item').length;
		let width = length >= 4 ? 1120 : (length * 228 ) ;
		$('.promotion-thumb').css('width', width);
	}*/

	setSlick = () => {
		const _this = this;
		let _isRtl = _this.config.isRtl;
		$('.promotion-list').slick({
			dots: false,
			arrows: true,
			infinite: true,
			fade: true,
			prevArrow: $('.promotion-button-prev'),
			nextArrow: $('.promotion-button-next'),
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 7000,
			rtl: _isRtl
			// cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)'
		}).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			// console.log('* promotion : ', currentSlide , nextSlide , slick.currentDirection );

			if(!$(`.promotion-thumb .slick-slide[data-slick-index=${nextSlide}]`).hasClass('slick-active')) {
				// nav 판 이동시
				if(nextSlide > currentSlide && currentSlide != 0) {
					$('.promotion-thumb').slick('slickNext');
				} else if(currentSlide + 1 == slick.slideCount && nextSlide == 0){
					$('.promotion-thumb').slick('slickNext');
				} else {
					$('.promotion-thumb').slick('slickPrev');
				}
				$('.promotion-thumb .slick-slide').removeClass('slick-current');
				$(`.promotion-thumb .slick-slide[data-slick-index=${nextSlide}]`).addClass('slick-current');
			} else {
				// 판 이동없이 current 변경시
				$('.promotion-thumb .slick-slide').removeClass('slick-current');
				$(`.promotion-thumb .slick-slide[data-slick-index=${nextSlide}]`).addClass('slick-current');
			}
		});

		$('.promotion-list').on('afterChange', function(event, slick, currentSlide){
			// console.log("afterChange");
			_this.setActiveVideoPlay();
		});

		const wrap = $('.home-promotion');
		const slickLength = $('.promotion-list').slick("getSlick").slideCount;
		$('.promotion-pagination', wrap).empty().html(`<strong>1</strong>/${slickLength}`);

		$('.promotion-list').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			$('.promotion-pagination', wrap).empty().html(`<strong>${nextSlide + 1}</strong>/${slick.slideCount}`);
		});

		$('.promotion-thumb').slick({
			dots: false,
			arrows: false,
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 4,
			swipe: false,
			rtl: _isRtl
		});
		$(window).on('resize orientationchange', function() {
			$('.promotion-list').slick('resize');
			$('.promotion-thumb').slick('resize');
		});

		$('.promotion-thumb .slick-slide').on('click', (e) => {
			if($(e.currentTarget).hasClass('slick-current')) return false;
			$(e.currentTarget).siblings().removeClass('slick-current');
			$(e.currentTarget).addClass('slick-current');
			$('.promotion-list').slick('slickGoTo', $(e.currentTarget).data('slick-index'));
		});

		// nav over autoplay 정지
		$('.promotion-list').on('mouseover', (e) => {
			$('.promotion-list').slick('slickPause');
		});
		$('.promotion-list').on('mouseout', (e) => {
			$('.promotion-list').slick('slickPlay');
		});

	}

	onWindowResize = () => {
		// this.setSwiperPagination();
		this.resizeMovie();
	}

	setActiveVideoPlay() {
		// console.log('setActiveVideoPlay  start');
		$('.promotion-list video').each((i, v) => { v.pause(); });
		let $active =  $('.promotion-list .slick-current');
		let $activeVideoWrap = $('.promotion-movie', $active);
		// console.log($activeVideoWrap.length);
		if ($activeVideoWrap.length <= 0) { return false; }
		// console.log( ' $(video, $activeVideoWrap)[0] : ', $('video', $activeVideoWrap), $('video', $activeVideoWrap)[0] );
		$('video', $activeVideoWrap).length > 0 && $('video', $activeVideoWrap)[0].play();
	}

	resizeMovie = () => {
		let $promoList = $('.promotion-list');
		const _w = $promoList.width();
		let _h = $promoList.height(),
			_vw = Math.floor((_h * 32) / 9), //16:9 //21:9 1920:460
			_vmargin = (_w - _vw) / 2;
		// video
		if (_w > _vw) {
			_h = (_w * 9) / 32;
			_vw = _w;
			_vmargin = 0;
		}
		$promoList.find('video').css({
			width: _vw + 'px',
			height: _h + 'px',
			'margin-left': _vmargin + 'px'
		});
	};

	toggleEvent() {
		let openHandler = document.querySelector('.promotion-listall-button');
		let closeHandler = document.querySelector('.promotion-listall-close');
		let listWrapper = document.querySelector('.promotion-listall-wrapper');
		openHandler.addEventListener('click', (evt) => {
			listWrapper.classList.add('is-active');
			evt.currentTarget.classList.remove('is-active');
		});
		closeHandler.addEventListener('click', (evt) => {
			openHandler.classList.add('is-active');
			listWrapper.classList.remove('is-active');
			evt.currentTarget.classList.remove('is-active');
		});
	}

}